import { render, staticRenderFns } from "./BusinessParent.vue?vue&type=template&id=2ddbbbbc&"
import script from "./BusinessParent.vue?vue&type=script&lang=js&"
export * from "./BusinessParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports